/* eslint-disable @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment */
import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog'
import { ComponentType } from '@angular/cdk/portal'
import { AbstractDialogComponent } from './abstract-dialog.component'
import { ConfirmationComponent } from './confirmation/confirmation.component'
import { DialogsModule } from './dialogs.module'
import { DialogWrapperComponent } from './dialog-wrapper.component'
import { ConfigType } from '@app/core/constants/configType'
import { MessageDialogComponent } from './message-dialog/message-dialog.component'
import { InfoDialogComponent } from './info-dialog/info-dialog.component'

@Injectable({
  providedIn: DialogsModule,
})
export class DialogService {
  constructor(public matDialog: MatDialog) {}

  protected openDialog<T = AbstractDialogComponent>(
    dialogComponent: ComponentType<T>,
    projectedComponent?: any,
    projectedData?: any,
    config?: MatDialogConfig,
  ) {
    const dialogConfig = {
      panelClass: 'linxio-dialog',
      disableClose: true,
      restoreFocus: false,
      width: '400px',
      ...config,
      data: {
        ...(config && config.data),
        component: projectedComponent,
        data: projectedData,
      },
    }

    return this.matDialog.open<T>(dialogComponent, dialogConfig)
  }

  public confirm(message: string, header = 'DIALOGS.MESSAGES.WARNING') {
    return this.openDialog(DialogWrapperComponent, ConfirmationComponent, { message }, { disableClose: true, data: { header } })
  }

  protected message(messageConfig: object) {
    const dialogConfig = {
      autoFocus: false,
      width: '350px',
      data: messageConfig,
    }

    return this.openDialog(MessageDialogComponent, null, null, dialogConfig)
  }

  public info(title: string, message: string) {
    return this.open(InfoDialogComponent, title, message)
  }

  public warning(message: string, title?: string, subTitle?: string, shouldBeTranslated?: boolean) {
    return this.message({
      message,
      title,
      subTitle,
      type: ConfigType.typeWarning,
      shouldBeTranslated,
    })
  }

  public error(message: string, title?: string, subTitle?: string, shouldBeTranslated?: boolean) {
    return this.message({
      message,
      title,
      subTitle,
      type: ConfigType.typeError,
      shouldBeTranslated,
    })
  }

  public success(message: string, title?: string, subTitle?: string, shouldBeTranslated?: boolean) {
    return this.message({
      message,
      title,
      subTitle,
      type: ConfigType.typeSuccess,
      shouldBeTranslated,
    })
  }

  public open(component: ComponentType<any>, header: string, data?: any, width?: number, config?: MatDialogConfig) {
    return this.openDialog(DialogWrapperComponent, component, data, {
      data: { header },
      ...(width && { width: `${width}px` }),
      ...(config && config),
    })
  }

  public fluid(component: ComponentType<any>, header: string, data?: any) {
    return this.openDialog(DialogWrapperComponent, component, data, { data: { header }, width: 'auto' })
  }

  public legacy<T>(component: ComponentType<T>, data: any) {
    return this.matDialog.open(component, {
      panelClass: 'linxio-dialog',
      disableClose: true,
      data,
    })
  }

  public retry(message: string, header: string): MatDialogRef<ConfirmationComponent> {
    return this.openDialog<ConfirmationComponent>(
      DialogWrapperComponent,
      ConfirmationComponent,
      { message },
      {
        disableClose: true,
        data: { header },
      },
    )
  }
}
